angular.module('backOffice').controller('PageWrapperController', pageWrapperController);

pageWrapperController.$inject = ['$scope', 'entitlementsService'];

function pageWrapperController($scope, entitlementsService) {
    $scope.hasEntitlement = function (key) {
        return entitlementsService.hasEntitlement(key);
    };
}
